export interface RetryConfiguration {
  maxRetries: number;
  baseDelayMs: number;
  maxDelayMs: number;
  jitterMaxMs: number;
}

export interface ClientConfiguration {
  apiTimeout: number;
  pollingInterval: number;
  measurementTimeout: number;
  retry: RetryConfiguration;
}

// Default configuration (used if API unavailable)
export const DEFAULT_CONFIG: ClientConfiguration = {
  apiTimeout: 30000,
  pollingInterval: 5000,
  measurementTimeout: 120000,
  retry: {
    maxRetries: 3,
    baseDelayMs: 1000,
    maxDelayMs: 30000,
    jitterMaxMs: 500,
  },
};
